import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ExcelService } from 'src/app/services/excel.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { SpcenterdataService } from 'src/app/services/spcenterdata.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { AdditionalFeaturesPopupComponent } from '../additional-features-popup/additional-features-popup.component';
import { AddDevicePopupComponent } from '../add-device-popup/add-device-popup.component';
import { MatSelectChange } from '@angular/material/select';
import Swal from 'sweetalert2';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-manage-device',
  templateUrl: './manage-device.component.html',
  styleUrls: ['./manage-device.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
      transition('expanded <=> collapsed', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ManageDeviceComponent implements OnInit {
  form: FormGroup;
  data = [];
  filterdata: any;
  dataExcel: any = [];
  excelColumns: string[];
  filterOpen: boolean = false
  alldevices: any;
  deviceStatus: any;
  showfilter = false
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "model",
    "version",
    "serial",
    "mac",
    "status",
    "assignedto",
    "assignedfrom",
    "InvoiceNumber",
    "Supplier",
    "PurchasedDesign"
  ];
  filter: any = [
    { key: 1, value: 'All' },
    { key: 2, value: 'Available' },
    { key: 3, value: 'Not Available' },
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(
    private fromBuilder: FormBuilder,
    private SpcenterdataService: SpcenterdataService,
    private LookupDataService: LookupDataServiceService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private excelService: ExcelService,
    private matdialog: MatDialog,

  ) { }

  ngOnInit(): void {
    this.form = this.fromBuilder.group({
      search: [],
      filter: [this.filter[0].key],
    })


    this.getTableData();
    this.getEnumDeviceStatus();

  }

  getTableData() {
    this.SpcenterdataService.getDeviceOnLoad().subscribe((result) => {
      console.log(result);
      this.alldevices = result;
      this.data = result;
      this.data.forEach(item => {
        if (item.var3 && !(item.var3 instanceof Date)) {
          // Convert "19-02-2025 00:00:00" to a valid ISO date string
          const parts = item.var3.split(' ');
          const dateParts = parts[0].split('-'); // Split "19-02-2025" into ["19", "02", "2025"]
          const timePart = parts[1]; // Get the time part "00:00:00"

          // Rearrange to "2025-02-19T00:00:00"
          const isoDateString = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}T${timePart}`;
          const parsedDate = new Date(isoDateString);

          // Validate the date before assigning
          if (!isNaN(parsedDate.getTime())) {
            item.var3 = parsedDate;
          } else {
            console.warn(`Invalid date format for var3: ${item.var3}`);
          }
        }
      });
      this.dataExcel = result;
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;

    })
  }
  getEnumDeviceStatus() {
    this.LookupDataService.getEnumDeviceStatus(true).subscribe((result) => {
      this.deviceStatus = result;
      console.log(result)

    })

  }

  filtertoggle() {
    this.showfilter = this.showfilter ? false : true
  }
  searchinput() {
    let value = { searchQuery: this.form.value.search }
    console.log(value);
    if (value != null && value.searchQuery != '') {
      this.SpcenterdataService.getDeviceSearch(value).subscribe((result) => {
        if (result) {
          this.dataSource = new MatTableDataSource(result);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
        else
          this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      })
    }
    else
      this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  exportAsXLSX(): void {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "S.No",
        "model",
        "version",
        "serial",
        "mac",
        "status",
        "assignedto",
        "assignedfrom"
      ];
      exportData.forEach((a, index) => {
        excelList.push({
          sno: ++index,
          "model": a.model,
          "version": a.software_version,
          "serial": a.serial,
          "mac": a.mac,
          "status": a.deviceStatusName,
          assignedto: a.customerName,
          assignedfrom: a.assignedfrom
        });
      });
      this.excelService.exportAsExcelFile(excelList, "Device_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }

  gotoadddevice() {
    const dialogref = this.matdialog.open(AddDevicePopupComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: "50%",
      data: {
        title: 'newdevice',
        head: 'Add Device'
      }
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res)
        this.getTableData()
    })
  }


  clearFilter() {
    this.getTableData();
    this.form.controls['search'].setValue('');

  }

  getFilter(event: any) {
    console.log(event)
    let key = event
    this.filterdata = this.data;
    if (key == 2) {
      this.filterdata = this.data.filter(x => x.deviceStatus == 1)
      console.log(this.filterdata);
    }
    if (key == 3) {
      this.filterdata = this.data.filter(x => x.deviceStatus == 2)
      console.log(this.filterdata);
    }
    this.dataSource = new MatTableDataSource(this.filterdata);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

  }

  reset() {
    this.form.controls['filter'].setValue(this.filter[0].key);
    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

  }
  importexcel() {
    const dialogref = this.matdialog.open(AddDevicePopupComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: "40%",
      data: {
        title: 'excelimport',
        head: 'Import Device'
      }
    });
    dialogref.afterClosed().subscribe((result) => {
      if (result)
        this.SpcenterdataService.saveBulkInventoryDevice(result).subscribe((result) => {
          if (result) {
            Swal.fire('Error!', result, 'error')
            this.getTableData()
          }
          else {
            this.toastr.showSuccess('New Bulk Devices Added Succesfully')
            this.getTableData()
          }
        })
    })
  }
  applyFilter(filter: string) {
    if (filter == 'clear') {
      this.dataSource = new MatTableDataSource(this.data)
      this.dataSource.paginator = this.paginator
    }
    else {
      let value: any = []
      value = this.data.filter(x => x.deviceStatusName == filter)
      this.dataSource = new MatTableDataSource(value)
      this.dataSource.paginator = this.paginator
    }
  }
  get uniqueStatuses(): string[] {
    const allStatuses = this.data.flatMap(customer => customer.deviceStatusName);
    return Array.from(new Set(allStatuses));
  }
}
